export function footer() {
    if(window.outerWidth < 1024) {
        let footerMainNavs = document.querySelectorAll(".footerMainNav");
        for(let footerMainNav of footerMainNavs) {
            let name = footerMainNav.querySelector(".footerMenuName");
            let list = footerMainNav.querySelector("ul");
            if(name) {
                name.addEventListener("click", function() {
                    if(name.classList.contains("listOpen")) {
                        name.classList.remove("listOpen");
                    } else {
                        name.classList.add("listOpen");
                    }
                });
            }

        }
    }
}